// src/node_modules/@awesome.me/kit-63db24046b/icons/modules/kit/custom.mjs
var faActorsBorderless = {
  prefix: "fak",
  iconName: "actors-borderless",
  icon: [
    603,
    512,
    [],
    "e005",
    "M299.8 213.4A106.7 106.7 0 1 0 299.8 0a106.7 106.7 0 1 0 0 213.4zm-88 44.7l53.3 92.4c14.7 25.5 6 58.2-19.5 72.9l-92.4 53.4c-25.5 14.7-58.2 6-72.9-19.5L27 364.8c-14.7-25.5-6-58.2 19.5-72.9l92.4-53.3c25.5-14.7 58.2-6 72.9 19.5zm178.6-5.7c1.3-7.6 6.8-13.8 14.2-16s15.4-.1 20.7 5.6c37.2 39.6 102.5 109 136.8 145.5c4.8 5.1 6.7 12.4 4.8 19.2s-7.1 12.2-13.8 14.2c-44.8 13.4-126.3 37.8-171.1 51.2c-6.8 2-14.1 .4-19.4-4.3s-7.8-11.8-6.5-18.7c8.6-49.4 25-143.2 34.3-196.7z"
  ]
};
export {
  faActorsBorderless
};
